import { ReactElement, useCallback, useMemo } from "react";
import { LliLinkButton } from "@idwal/idwal-react-components";
import { ScreeningPscInspection } from "../../types/Screening";
import { LoadingParticulars } from "../loading/LoadingParticulars";
import { useTranslation } from "react-i18next";
import { sendGAEvent } from "../../services/AnalyticsService";
import {
    GA_BUTTON_EVENT,
    GA_CLICK_LLI_LINK
} from "../../constants/GaEvents";
import { ScreeningPSCAggregates } from "./ScreeningPscAggregates";
import { ScreeningPSCInspectionTable } from "./ScreeningPscInspectionTable";

type Props = {
    pscInspections: ScreeningPscInspection[];
    pscLoading: boolean;
};

export const ScreeningPscPerformance = (props: Props): ReactElement => {
    const { pscInspections, pscLoading } = props;

    const { t } = useTranslation("locale");

    const vesselId = useMemo(
        () => (pscInspections.length ? `${pscInspections[0].vessel_id}` : ""),
        [pscInspections]
    );

    const gaEvent = useCallback(() => {
        sendGAEvent(GA_BUTTON_EVENT, GA_CLICK_LLI_LINK);
    }, []);

    if (pscLoading) {
        return <LoadingParticulars />;
    }


    if (!pscInspections.length) {
        return (
            <p className="summary">{t("psc.noPscData")}</p>
        );
    }

    return (
        <div className="flex flex-column">
            <div className="flex justify-content-between">
                <p className="psc-header">
                    {t("psc.psc_performance_36")}
                </p>
                <LliLinkButton vesselId={vesselId} gaEvent={gaEvent} />
            </div>
            <ScreeningPSCAggregates pscInspections={pscInspections} />
            <ScreeningPSCInspectionTable pscInspections={pscInspections} />
        </div>
    );
};
